import React from 'react';
import GalleryItemContainer from '../containers/gallery-item-container'
import {grey700} from 'material-ui/styles/colors';

import './gallery.css';

const style = {
    h3:{
        color: grey700,
        fontWeight: 'normal',
        textAlign: 'left',
        paddingLeft: '2vw'
    },
    gallery: {
        paddingTop: 0,
        paddingBottom: 0
    },
    filler: {
        height: 1,
        background: 'transparent',
        marginBottom: 0
    }
};

// Using "Stateless Functional Components"
//
function GalleryGroup(props) {

    const listItems = props.assets.map(asset => {
        return <GalleryItemContainer
            key={asset.assetUUID || asset.tempUUID}
            userId={props.userId}
            {...asset}
        />;
        //return <a key={asset.id}><img src={href}/></a>
    });

    for (let i = 1; i < 8; i++) {
        listItems.push(<a className="wt-asset" key={i} style={style.filler}/>);
    }

    return (
        <div>
            <h3 className='sticky' style={style.h3}>{props.date}</h3>
            <div style={style.gallery} className="wt-gallery">
                {listItems}
            </div>
        </div>
    );
}

export default GalleryGroup;


